<template>
  <div v-if="bannerProductList.length > 0" class="slide-banner-container">
    <a @click="slidePrev()" href="javascript:void(0);" class="control-slide-btn control-prev">
      <i class="fal fa-angle-left"></i>
    </a>
    <a @click="slideNext()" href="javascript:void(0);" class="control-slide-btn control-next">
      <i class="fal fa-angle-right"></i>
    </a>
    <!-- <h4 class="slide-banner-title">
      <span class="title">{{ ls_OurProducts }}</span>
    </h4> -->
    <swiper class="slide-banner" :options="swiperOption">
      <swiper-slide v-for="(banner, index) in bannerProductList" :key="index">
        <div class="slide-banner-item">
          <b-link :href="banner.url" target="_blank" class="slide-item-link">
            <img class="slide-item-img" :src="bigThumnailUrl(host + banner.thumbnailUrl)" :alt="banner.title">
          </b-link>
        </div>
      </swiper-slide>
      <div ref="slidePrev" class="swiper-button-prev hidden" slot="button-prev"></div>
      <div ref="slideNext" class="swiper-button-next hidden" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
export default {
  data() {
    return {
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 30,
        slidesPerGroup: 1,
        loop: true,
        loopFillGroupWithBlank: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },

      bannerProductList: []
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    ls_OurProducts() {
      return this.$store.state.languagePack.ls_OurProducts;
    }
  },

  created() {
    this.getProductList();
  },

  methods: {
    slideNext() {
      if (this.$refs.slideNext) {
        this.$refs.slideNext.click();
      }
    },
    slidePrev() {
      if (this.$refs.slidePrev) {
        this.$refs.slidePrev.click();
      }
    },
    bigThumnailUrl(stringUrl) {
      return stringUrl.replace("_small.", "_big.");
    },

    getProductList() {
      let fd = new FormData();
      fd.append("language", this.$route.params.ln);
      this.$http
        .post(this.host + "/api/qazlatyn/getproductslist", fd)
        .then(result => {
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.bannerProductList = result.body.data;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.hidden {
  display: none;
}
.slide-banner-container {
  position: relative;
  z-index: 10;

  .control-slide-btn {
    position: absolute;
    top: 85px;
    display: inline-block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    z-index: 11;
    background-color: #ffffff;
    text-align: center;
    box-shadow: 0 0 0 1px rgba(0,0,0,0.04), 0 4px 8px 0 rgba(0,0,0,0.20);

    i {
      font-size: 30px;
      line-height: 40px;
      color: #959696;
    }
  }

  .control-prev {
    left: -20px;
  }
  .control-next {
    right: -20px;
  }
  .slide-banner-title {
    font-size: 1.125rem;
    color: #ffffff;
    border-bottom: 1px solid #d0dfdf;
    margin-bottom: 1rem;

    .title {
      display: inline-block;
      padding: 0.25rem 0.875rem;
      background-color: #008496;
    }
  }

  .slide-banner {
    padding-bottom: 2rem;

    .slide-banner-item {
      background-color: #ffffff;
      border: 1px solid #ededed;

      &:hover {
        border-color: #00849677;
      }

      .slide-item-link {
        .slide-item-img {
          width: 100%;
        }
      }
    }
  }

  .swiper-pagination-bullets {
    bottom: 0;
  }
}
</style>
